module.exports = __webpack_public_path__ + "img/smithsonian2.336febe7.jpg";